/*
 * @Description:
 * @Date: 2022-02-25 10:28:33
 */

import { activity } from '@/api/ajax';
import fields from './fields';
import search from './search';
import TableRenderClass from '@C/tableRender/tableRenderClass';
import createExtend from '@C/createExtend';
import activeAdd from '../../active-add';

let example = new TableRenderClass({ fields, search });

let part = example.createPart({
  name: '项目人员',
  list: activity.list,
  requestNow: true,
  search: ['authDaterange', 'shifouguoqi', 'auditOssStatus', 'activityName'],
  fields: [
    'index',
    'activityName',
    'activityPeopleSum',
    'submitDt',
    'submitStatus',
    'auditOssStatus',
    'handler'
  ],
  moreBtnArr: [
    {
      name: '添加活动',
      type: 'primary',
      async fn(app, table) {
        const creator = createExtend(activeAdd);
        // 确认添加后重载
        creator['$on']('confirm', () => {
          table.init();
        });
      }
    }
  ]
});

export default [{ name: '项目人员', childMenu: [part] }];
